(() => {
  const normalize = value => value.trim().replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit)).replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)).replace(/[\s().\-\u200e\u200f\u061c]/g, '').replace(/^(?:\+?212|00212)0?([67]\d{8})$/, '0$1');
  const trafficContext = (() => {
    const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ttclid'];
    const params = new URLSearchParams(location.search);
    const current = Object.fromEntries(keys.map(key => [key, (params.get(key) || '').slice(0,255)]));
    const tagged = keys.some(key => current[key]);
    let previous;
    try { previous = JSON.parse(sessionStorage.getItem('vivalle_traffic_session') || 'null'); } catch {}
    const fresh = previous && Date.now() - previous.recordedAt < 1800000;
    const chosen = tagged || !fresh ? { ...current, landing_page: location.href.slice(0,2048), referrer: document.referrer.slice(0,2048), recordedAt: Date.now() } : previous;
    try { sessionStorage.setItem('vivalle_traffic_session', JSON.stringify(chosen)); } catch {}
    const { recordedAt, ...fields } = chosen;
    return fields;
  })();
  const cookie = name => {
    const row = document.cookie.split('; ').find(item => item.startsWith(name + '='));
    try { return row ? decodeURIComponent(row.slice(name.length + 1)) : ''; } catch { return ''; }
  };
  const initializeVoiceNotes = root => {
    root.querySelectorAll('.vv-voice-section').forEach(section => {
      const track = section.querySelector('.vv-carousel-track');
      const viewport = section.querySelector('.vv-carousel-viewport');
      const carousel = section.querySelector('.vv-voice-carousel');
      const slides = Array.from(section.querySelectorAll('.vv-carousel-slide'));
      const players = Array.from(section.querySelectorAll('.vv-received-audio'));
      const dotsWrap = section.querySelector('.vv-carousel-dots');
      const status = section.querySelector('.vv-audio-status');
      const heights = [9,20,14,27,11,23,16,30,19,10,25,17,13,28,21,8,18,26,12,29,16,22,10,25,15,31,19,11,24,17,27,13,21,9,26,15];
      let currentSlide = 0;
      let pointerStart = null;
      const formatTime = seconds => Number.isFinite(seconds) && seconds >= 0 ? Math.floor(seconds / 60) + ':' + Math.floor(seconds % 60).toString().padStart(2, '0') : '0:00';
      const stopAllExcept = exception => players.forEach(player => {
        const audio = player.querySelector('audio');
        if (audio !== exception) audio.pause();
      });
      const goToSlide = index => {
        currentSlide = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        dotsWrap.querySelectorAll('.vv-carousel-dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentSlide);
          dot.setAttribute('aria-current', String(index === currentSlide));
        });
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', String(index !== currentSlide));
          slide.inert = index !== currentSlide;
        });
        status.hidden = true;
        stopAllExcept(null);
      };
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vv-carousel-dot';
        dot.setAttribute('aria-label', section.dataset.messageLabel + ' ' + (index + 1));
        dot.addEventListener('click', () => goToSlide(index));
        dotsWrap.appendChild(dot);
      });
      section.querySelector('.vv-carousel-prev').addEventListener('click', () => goToSlide(currentSlide - 1));
      section.querySelector('.vv-carousel-next').addEventListener('click', () => goToSlide(currentSlide + 1));
      viewport.addEventListener('pointerdown', event => {
        if (!event.target.closest('.vv-wave, .vv-audio-play')) pointerStart = event.clientX;
      });
      viewport.addEventListener('pointerup', event => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) > 45) goToSlide(currentSlide + (distance < 0 ? 1 : -1));
      });
      viewport.addEventListener('pointercancel', () => { pointerStart = null; });
      carousel.addEventListener('keydown', event => {
        if (event.target.closest('.vv-wave')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentSlide + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      players.forEach((player, playerIndex) => {
        const audio = player.querySelector('audio');
        const button = player.querySelector('.vv-audio-play');
        const wave = player.querySelector('.vv-wave');
        const base = player.querySelector('.vv-wave-bars-base');
        const played = player.querySelector('.vv-wave-bars-played');
        const progress = player.querySelector('.vv-wave-progress');
        const dot = player.querySelector('.vv-wave-dot');
        const duration = player.querySelector('.vv-audio-duration');
        let dragging = false;
        heights.forEach((height, barIndex) => {
          const adjusted = Math.max(7, height + ((barIndex + playerIndex * 5) % 5) - 2);
          [base, played].forEach(container => {
            const bar = document.createElement('span');
            bar.style.height = adjusted + 'px';
            container.appendChild(bar);
          });
        });
        const syncWidth = () => played.style.setProperty('--vv-wave-width', wave.clientWidth + 'px');
        const syncProgress = () => {
          const ratio = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.currentTime / audio.duration : 0;
          const percentage = Math.max(0, Math.min(100, ratio * 100));
          progress.style.width = percentage + '%';
          dot.style.left = percentage + '%';
          wave.setAttribute('aria-valuenow', Math.round(percentage));
          wave.setAttribute('aria-valuetext', formatTime(audio.currentTime) + ' / ' + formatTime(audio.duration));
          if (Number.isFinite(audio.duration)) duration.textContent = formatTime(audio.currentTime > 0 ? audio.currentTime : audio.duration);
        };
        const seek = clientX => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          const bounds = wave.getBoundingClientRect();
          audio.currentTime = Math.max(0, Math.min(1, (clientX - bounds.left) / bounds.width)) * audio.duration;
          syncProgress();
        };
        button.addEventListener('click', async () => {
          if (!audio.paused) { audio.pause(); return; }
          stopAllExcept(audio);
          status.hidden = true;
          const pending = audio.querySelectorAll('source[data-vv-audio-src]');
          if (pending.length) {
            pending.forEach(source => {
              source.src = source.getAttribute('data-vv-audio-src');
              source.removeAttribute('data-vv-audio-src');
            });
            audio.load();
          } else if (audio.error) audio.load();
          try { await audio.play(); }
          catch (error) {
            if (error.name !== 'AbortError' && currentSlide === playerIndex) {
              status.textContent = section.dataset.errorLabel;
              status.hidden = false;
            }
          }
        });
        wave.addEventListener('pointerdown', event => {
          dragging = true;
          wave.setPointerCapture(event.pointerId);
          seek(event.clientX);
        });
        wave.addEventListener('pointermove', event => { if (dragging) seek(event.clientX); });
        wave.addEventListener('pointerup', () => { dragging = false; });
        wave.addEventListener('pointercancel', () => { dragging = false; });
        wave.addEventListener('keydown', event => {
          if (!Number.isFinite(audio.duration) || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          audio.currentTime = event.key === 'Home' ? 0 : event.key === 'End' ? audio.duration : Math.max(0, Math.min(audio.duration, audio.currentTime + (event.key === 'ArrowRight' ? 5 : -5)));
          syncProgress();
        });
        const setPlaying = active => {
          player.classList.toggle('is-playing', active);
          button.setAttribute('aria-label', active ? section.dataset.pauseLabel : section.dataset.playLabel);
          button.setAttribute('aria-pressed', String(active));
        };
        audio.addEventListener('play', () => {
          if (currentSlide !== playerIndex) { audio.pause(); return; }
          stopAllExcept(audio);
          setPlaying(true);
        });
        audio.addEventListener('pause', () => setPlaying(false));
        audio.addEventListener('loadedmetadata', () => { syncWidth(); syncProgress(); });
        audio.addEventListener('timeupdate', syncProgress);
        audio.addEventListener('ended', () => { setPlaying(false); audio.currentTime = 0; syncProgress(); });
        new ResizeObserver(syncWidth).observe(wave);
        setPlaying(false);
        syncWidth();
      });
      goToSlide(0);
    });
  };

  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const valueSection = root.querySelector('[data-vc-value]');
    if (valueSection) {
      const shell = valueSection.querySelector('.vc-value-shell');
      const creamButtons = Array.from(valueSection.querySelectorAll('.vc-value-cream'));
      const careStatus = valueSection.querySelector('[data-care-status]');
      const defaultDetail = careStatus.textContent;
      const careFeedback = valueSection.querySelector('[data-care-feedback]');
      const combine = valueSection.querySelector('[data-care-combine]');
      const claim = valueSection.querySelector('[data-care-claim]');
      const progress = valueSection.querySelector('.vc-value-progress');
      const progressFill = valueSection.querySelector('.vc-value-progress-fill');
      const count = valueSection.querySelector('[data-care-count]');
      const stage = valueSection.querySelector('[data-brew-stage]');
      const result = valueSection.querySelector('[data-brew-result]');
      const prelude = valueSection.querySelector('[data-brew-prelude]');
      const vessel = valueSection.querySelector('[data-lab-drop]');
      const fill = valueSection.querySelector('[data-lab-fill]');
      const cue = valueSection.querySelector('[data-brew-cue]');
      const symbol = valueSection.querySelector('[data-brew-symbol]');
      const selectedCare = new Set();
      const consultButton = valueSection.querySelector('[data-care-consult]');
      const priceTotal = valueSection.querySelector('[data-care-total]');
      const finalPriceTotal = valueSection.querySelector('[data-care-final-total]');
      const calculateValue = () => creamButtons.reduce((sum,item) => sum + (selectedCare.has(item.dataset.vcCare) ? Number(item.dataset.carePrice || 0) : 0), 0) + (consultButton?.getAttribute('aria-pressed') === 'true' ? 300 : 0);
      consultButton?.addEventListener('click', () => {
        if (busy || phase !== 'idle') return;
        consultButton.setAttribute('aria-pressed', String(consultButton.getAttribute('aria-pressed') !== 'true'));
        syncCare();
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let busy = false;
      let phase = 'idle';
      let activeDrag = null;
      let ignoreClicksUntil = 0;
      let smokeTimer = 0;
      let celebrationNode = null;
      let celebrationAnimations = [];
      const clearCelebration = () => {
        celebrationAnimations.forEach(animation => animation.cancel());
        celebrationAnimations = [];
        celebrationNode?.remove();
        celebrationNode = null;
      };
      const celebrate = () => {
        clearCelebration();
        if (reducedMotion.matches) return;
        const confetti = document.createElement('div');
        confetti.className = 'vc-lab-confetti';
        confetti.setAttribute('aria-hidden', 'true');
        const palette = ['#e4573d', '#426654', '#dbb887', '#203a4f', '#d5bfb0'];
        const spread = Math.min(stage.clientWidth * .44, 300);
        for (let i = 0; i < 28; i++) {
          const piece = document.createElement('span');
          piece.style.background = palette[i % palette.length];
          if (i % 4 === 0) piece.className = 'is-round';
          confetti.append(piece);
          const side = i % 2 ? 1 : -1;
          const reach = 75 + Math.random() * 105;
          const drift = side * (35 + Math.random() * spread);
          const turn = side * (180 + Math.random() * 360);
          celebrationAnimations.push(piece.animate([
            { transform: 'translate(0,0) rotate(0deg) scale(.3)', opacity: 0 },
            { transform: `translate(${drift * .35}px,${-reach * .65}px) rotate(${turn * .3}deg) scale(1)`, opacity: 1, offset: .2 },
            { transform: `translate(${drift * .7}px,${-reach}px) rotate(${turn * .65}deg) scale(1)`, opacity: 1, offset: .45 },
            { transform: `translate(${drift}px,${125 + Math.random() * 75}px) rotate(${turn}deg) scale(.8)`, opacity: 0 }
          ], { duration: 1900 + Math.random() * 500, delay: Math.random() * 90, easing: 'cubic-bezier(.15,.55,.4,1)', fill: 'both' }));
        }
        stage.append(confetti);
        celebrationNode = confetti;
        Promise.allSettled(celebrationAnimations.map(animation => animation.finished)).then(() => {
          confetti.remove();
          if (celebrationNode === confetti) { celebrationNode = null; celebrationAnimations = []; }
        });
      };
      valueSection.querySelector('[data-care-play]').hidden = false;
      const previewCare = item => {
        if (busy) return;
        careStatus.textContent = item ? item.dataset.careDetail : (phase === 'revealed' ? careStatus.dataset.careComplete : defaultDetail);
        shell.toggleAttribute('data-care-active', Boolean(item) || phase === 'revealed');
        if (careFeedback) { careFeedback.textContent = item && phase === 'idle' ? item.dataset.careDetail : ''; careFeedback.hidden = !careFeedback.textContent; }
      };
      const syncCare = () => {
        const estimatedTotal = calculateValue();
        if (priceTotal) priceTotal.textContent = estimatedTotal.toLocaleString('fr-MA');
        if (finalPriceTotal) finalPriceTotal.textContent = estimatedTotal.toLocaleString('fr-MA');
        if (consultButton) consultButton.disabled = busy || phase === 'revealed';

        creamButtons.forEach(item => {
          item.setAttribute('aria-pressed', String(selectedCare.has(item.dataset.vcCare)));
          item.disabled = busy || phase === 'revealed';
        });
        valueSection.querySelectorAll('[data-care-chip]').forEach(chip => chip.classList.toggle('is-collected', selectedCare.has(chip.dataset.careChip)));
        progress.setAttribute('aria-valuenow', String(selectedCare.size + (consultButton?.getAttribute('aria-pressed') === 'true' ? 1 : 0)));
        progressFill.style.width = ((selectedCare.size + (consultButton?.getAttribute('aria-pressed') === 'true' ? 1 : 0)) * 20) + '%';
        count.textContent = (selectedCare.size + (consultButton?.getAttribute('aria-pressed') === 'true' ? 1 : 0)) + ' / 5';
        fill.style.height = selectedCare.size ? (10 + selectedCare.size * 11) + '%' : '0%';
        fill.style.opacity = selectedCare.size ? '1' : '0';
        combine.disabled = busy || selectedCare.size < 4 || consultButton?.getAttribute('aria-pressed') !== 'true';
        combine.hidden = phase === 'revealed';
        claim.hidden = phase !== 'revealed';
        combine.textContent = busy ? combine.dataset.mixingLabel : combine.dataset.combineLabel;
        cue.textContent = busy ? cue.dataset.mixingCue : (selectedCare.size === 4 && consultButton?.getAttribute('aria-pressed') === 'true' ? cue.dataset.readyCue : cue.dataset.idleCue);
        shell.classList.toggle('is-complete', phase === 'revealed');
      };
      const setPhase = next => {
        phase = next;
        shell.dataset.brewPhase = next;
        result.setAttribute('aria-hidden', String(next !== 'revealed'));
        prelude.setAttribute('aria-hidden', String(next === 'revealed'));
        stage.setAttribute('aria-busy', String(busy));
        symbol.textContent = next === 'revealed' ? '=' : '?';
        syncCare();
      };
      const makeGhost = item => {
        const picture = item.querySelector('img');
        if (!picture.complete || !picture.naturalWidth) return null;
        const from = picture.getBoundingClientRect();
        const frame = shell.getBoundingClientRect();
        const ghost = picture.cloneNode(false);
        ghost.className = 'vc-value-fly';
        ghost.setAttribute('aria-hidden', 'true');
        ghost.removeAttribute('loading');
        ghost.style.left = (from.left - frame.left) + 'px';
        ghost.style.top = (from.top - frame.top) + 'px';
        ghost.style.width = from.width + 'px';
        ghost.style.height = from.height + 'px';
        shell.appendChild(ghost);
        return {ghost,from};
      };
      const isOverVessel = (x,y) => {
        const box = vessel.getBoundingClientRect();
        return x >= box.left && x <= box.right && y >= box.top && y <= box.bottom;
      };
      const absorbGhost = (ghost, from, dx = 0, dy = 0) => {
        if (!ghost) return;
        const to = vessel.getBoundingClientRect();
        const tx = to.left + to.width / 2 - from.left - from.width / 2;
        const ty = to.top + to.height * .6 - from.top - from.height / 2;
        if (reducedMotion.matches) { ghost.remove(); return; }
        const motion = ghost.animate([
          {transform:'translate(' + dx + 'px,' + dy + 'px) scale(1)',opacity:.95},
          {transform:'translate(' + tx + 'px,' + ty + 'px) scale(.1)',opacity:0}
        ],{duration:320,easing:'ease-in',fill:'forwards'});
        motion.finished.then(() => ghost.remove(),() => ghost.remove());
        vessel.animate([{transform:'scale(1)'},{transform:'scale(1.045)'},{transform:'scale(1)'}],{duration:350,easing:'ease-out'});
      };
      const addCare = (item, drag = null) => {
        const key = item.dataset.vcCare;
        if (selectedCare.has(key) || busy || phase !== 'idle') {
          if (drag && drag.ghost) drag.ghost.remove();
          return;
        }
        selectedCare.add(key);
        syncCare();
        previewCare(item);
        const visual = drag || makeGhost(item);
        if (visual) absorbGhost(visual.ghost,visual.from,visual.dx || 0,visual.dy || 0);
      };
      const finishDrag = (event,cancelled = false) => {
        if (!activeDrag || activeDrag.id !== event.pointerId) return;
        const drag = activeDrag;
        activeDrag = null;
        vessel.classList.remove('is-drop-target');
        shell.classList.remove('is-dragging');
        drag.item.classList.remove('is-dragging');
        if (drag.item.hasPointerCapture(event.pointerId)) drag.item.releasePointerCapture(event.pointerId);
        if (!drag.moved) return;
        ignoreClicksUntil = Date.now() + 450;
        if (!cancelled && isOverVessel(event.clientX,event.clientY)) {
          addCare(drag.item,drag);
        } else if (drag.ghost) {
          if (reducedMotion.matches) drag.ghost.remove();
          else {
            const back = drag.ghost.animate([
              {transform:'translate(' + drag.dx + 'px,' + drag.dy + 'px) scale(1.05)',opacity:.9},
              {transform:'translate(0,0) scale(1)',opacity:0}
            ],{duration:220,easing:'ease-out',fill:'forwards'});
            back.finished.then(() => drag.ghost.remove(),() => drag.ghost.remove());
          }
        }
      };
      creamButtons.forEach(item => {
        item.addEventListener('pointerdown',event => {
          if (event.button !== 0 || busy || phase !== 'idle' || activeDrag) return;
          item.focus({preventScroll:true});
          item.setPointerCapture(event.pointerId);
          activeDrag = {item,id:event.pointerId,startX:event.clientX,startY:event.clientY,dx:0,dy:0,moved:false,ghost:null,from:null};
        });
        item.addEventListener('pointermove',event => {
          if (!activeDrag || activeDrag.id !== event.pointerId) return;
          const drag = activeDrag;
          drag.dx = event.clientX - drag.startX;
          drag.dy = event.clientY - drag.startY;
          if (!drag.moved && Math.hypot(drag.dx,drag.dy) < 7) return;
          if (!drag.moved) {
            drag.moved = true;
            const visual = makeGhost(item);
            if (visual) { drag.ghost = visual.ghost; drag.from = visual.from; }
            item.classList.add('is-dragging');
            shell.classList.add('is-dragging');
          }
          event.preventDefault();
          if (drag.ghost) drag.ghost.style.transform = 'translate(' + drag.dx + 'px,' + drag.dy + 'px) scale(1.05)';
          vessel.classList.toggle('is-drop-target',isOverVessel(event.clientX,event.clientY));
        });
        item.addEventListener('pointerup',event => finishDrag(event));
        item.addEventListener('pointercancel',event => finishDrag(event,true));
        item.addEventListener('lostpointercapture',event => {
          if (activeDrag && activeDrag.id === event.pointerId) finishDrag(event,true);
        });
        item.addEventListener('dragstart',event => event.preventDefault());
        item.addEventListener('click',event => {
          if (Date.now() < ignoreClicksUntil || busy || phase !== 'idle') {event.preventDefault();return;}
          if (selectedCare.has(item.dataset.vcCare)) {
            selectedCare.delete(item.dataset.vcCare);
            syncCare();
            previewCare(null);
          } else addCare(item);
        });
        item.addEventListener('focus',() => previewCare(item));
        item.addEventListener('blur',() => previewCare(null));
      });
      combine.addEventListener('click',async () => {
        if (busy || phase === 'revealed') return;
        if (selectedCare.size !== 4) return;
        busy = true;
        const revealImages = Array.from(result.querySelectorAll('img'));
        revealImages.forEach(image => { image.loading = 'eager'; });
        const imagesReady = Promise.allSettled(revealImages.map(image => image.decode()));
        setPhase('mixing');
        careStatus.textContent = combine.dataset.mixingLabel;
        if (!reducedMotion.matches) {
          await new Promise(resolve => window.setTimeout(resolve,1100));
          if (!valueSection.isConnected) return;
          shell.classList.add('is-smoking');
          smokeTimer = window.setTimeout(() => shell.classList.remove('is-smoking'),2050);
          await new Promise(resolve => window.setTimeout(resolve,650));
        }
        await imagesReady;
        busy = false;
        if (!valueSection.isConnected) return;
        setPhase('revealed');
        celebrate();
        previewCare(null);
      });
      claim.addEventListener('click', event => {
        const orderPanel = root.querySelector('.vc-order-panel');
        if (!orderPanel) return;
        event.preventDefault();
        orderPanel.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
      setPhase('idle');

      let guideStopped = false;
      let guideInView = false;
      let guideTimer = 0;
      let guideLastPlayed = 0;
      let guideNode = null;
      let guideAnimations = [];
      let guideObserver = null;
      const dismissGuide = (permanent = false) => {
        window.clearTimeout(guideTimer);
        guideTimer = 0;
        if (permanent) { guideStopped = true; guideObserver?.disconnect(); }
        guideAnimations.forEach(animation => animation.cancel());
        guideAnimations = [];
        guideNode?.remove();
        guideNode = null;
      };
      const scheduleGuide = () => {
        if (guideTimer || guideNode || guideStopped || !guideInView || document.hidden || reducedMotion.matches || phase !== 'idle' || selectedCare.size || !valueSection.isConnected) return;
        const delay = guideLastPlayed ? Math.max(0, 6000 - (performance.now() - guideLastPlayed)) : 0;
        guideTimer = window.setTimeout(() => { guideTimer = 0; showGuide(); }, delay);
      };
      const showGuide = () => {
        if (guideStopped || guideNode || !guideInView || document.hidden || reducedMotion.matches || phase !== 'idle' || selectedCare.size || activeDrag || !valueSection.isConnected) return;
        const source = creamButtons[0]?.querySelector('img');
        if (!source?.complete || !source.naturalWidth) return;
        const from = source.getBoundingClientRect();
        const to = vessel.getBoundingClientRect();
        const visibleTop = window.visualViewport?.offsetTop || 0;
        const visibleBottom = visibleTop + (window.visualViewport?.height || window.innerHeight);
        const sourceCenterY = from.top + from.height * .45;
        const endY = to.top + to.height * .38;
        if (!from.width || !from.height || !to.width || !to.height || sourceCenterY < visibleTop + 12 || sourceCenterY > visibleBottom - 12) return;
        guideLastPlayed = performance.now();
        const frame = shell.getBoundingClientRect();
        const start = { x: from.left + from.width / 2 - frame.left, y: from.top + from.height * .45 - frame.top };
        const end = { x: to.left + to.width / 2 - frame.left, y: endY - frame.top };
        const control = { x: end.x + Math.min(65, frame.width * .12), y: start.y + (end.y - start.y) * .4 };
        const overlay = document.createElement('div');
        overlay.className = 'vc-lab-guide';
        overlay.dataset.guideStarted = String(guideLastPlayed);
        overlay.setAttribute('aria-hidden', 'true');
        const svgNS = 'http://www.w3.org/2000/svg';
        const arrow = document.createElementNS(svgNS, 'svg');
        arrow.setAttribute('viewBox', `0 0 ${frame.width} ${frame.height}`);
        arrow.classList.add('vc-lab-guide-arrow');
        const path = document.createElementNS(svgNS, 'path');
        path.setAttribute('d', `M ${start.x + 17} ${start.y + 22} Q ${control.x} ${control.y} ${end.x} ${end.y}`);
        const head = document.createElementNS(svgNS, 'path');
        const angle = Math.atan2(end.y - control.y, end.x - control.x);
        head.setAttribute('d', `M ${end.x - 10 * Math.cos(angle - .5)} ${end.y - 10 * Math.sin(angle - .5)} L ${end.x} ${end.y} L ${end.x - 10 * Math.cos(angle + .5)} ${end.y - 10 * Math.sin(angle + .5)}`);
        arrow.append(path, head);
        const ghost = source.cloneNode(false);
        ghost.className = 'vc-lab-guide-cream';
        ghost.alt = '';
        ghost.draggable = false;
        Object.assign(ghost.style, { left: from.left - frame.left + 'px', top: from.top - frame.top + 'px', width: from.width + 'px', height: from.height + 'px' });
        const hand = document.createElementNS(svgNS, 'svg');
        hand.setAttribute('viewBox', '0 0 48 56');
        hand.classList.add('vc-lab-guide-hand');
        Object.assign(hand.style, { left: start.x - 18 + 'px', top: start.y - 3 + 'px' });
        const palm = document.createElementNS(svgNS, 'path');
        palm.setAttribute('d', 'M18 31V8a4 4 0 0 1 8 0v16c0-5 8-5 8 0v2c0-4 7-4 7 1v2c0-3 6-3 6 1v9c0 7-4 11-7 15H23c-2-6-6-10-10-15l-5-7c-3-5 3-9 6-5l4 4Z');
        hand.append(palm);
        const ripple = document.createElement('span');
        ripple.className = 'vc-lab-guide-ripple';
        Object.assign(ripple.style, { left: start.x - 19 + 'px', top: start.y - 19 + 'px' });
        overlay.append(arrow, ghost, ripple, hand);
        shell.append(overlay);
        guideNode = overlay;
        const duration = 3000;
        const settings = { duration, easing: 'linear', fill: 'both' };
        const position = t => ({ x: 2 * (1 - t) * t * (control.x - start.x) + t * t * (end.x - start.x), y: 2 * (1 - t) * t * (control.y - start.y) + t * t * (end.y - start.y) });
        const movingFrames = (isHand) => {
          const frames = [
            { transform: 'translate(0,0) scale(1)', opacity: 0, offset: 0 },
            { transform: 'translate(0,0) scale(1)', opacity: 1, offset: .12 },
            { transform: 'translate(0,0) scale(1.04)', opacity: 1, offset: .28 }
          ];
          for (let i = 1; i <= 16; i++) {
            const t = i / 16;
            const p = position(t * t * (3 - 2 * t));
            frames.push({ transform: `translate(${p.x}px,${p.y}px) scale(${isHand ? 1 : 1.04 - .2 * t})`, opacity: 1, offset: .28 + t * .55 });
          }
          const p = position(1);
          frames.push({ transform: `translate(${p.x}px,${p.y + (isHand ? 0 : 20)}px) scale(${isHand ? .96 : .12})`, opacity: 0, offset: 1 });
          return frames;
        };
        guideAnimations = [
          ghost.animate(movingFrames(false), settings),
          hand.animate(movingFrames(true), settings),
          arrow.animate([{ opacity: 0 }, { opacity: .48, offset: .2 }, { opacity: .48, offset: .75 }, { opacity: 0 }], settings),
          ripple.animate([{ opacity: 0, transform: 'scale(.6)' }, { opacity: .35, offset: .15 }, { opacity: 0, transform: 'scale(1.65)', offset: .3 }, { opacity: 0 }], settings)
        ];
        Promise.allSettled(guideAnimations.map(animation => animation.finished)).then(() => {
          overlay.remove();
          if (guideNode === overlay) { guideNode = null; guideAnimations = []; scheduleGuide(); }
        });
      };
      const guideInteraction = event => {
        if (event.target.closest('.vc-value-cream,.vc-value-combine')) dismissGuide(true);
      };
      ['pointerdown', 'click'].forEach(type => valueSection.addEventListener(type, guideInteraction, true));
      const refreshGuideViewport = () => { dismissGuide(); scheduleGuide(); };
      window.addEventListener('resize', refreshGuideViewport);
      window.visualViewport?.addEventListener('resize', refreshGuideViewport);
      window.visualViewport?.addEventListener('scroll', scheduleGuide, { passive: true });
      window.addEventListener('scroll', scheduleGuide, { passive: true });
      document.addEventListener('visibilitychange', () => { if (document.hidden) dismissGuide(); else scheduleGuide(); });
      reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) { dismissGuide(); clearCelebration(); } else scheduleGuide(); });
      if ('IntersectionObserver' in window) {
        guideObserver = new IntersectionObserver(entries => {
          guideInView = entries.some(entry => entry.isIntersecting);
          if (guideInView) scheduleGuide();
          else dismissGuide();
        }, { threshold: [0, .25, .5, .75, 1] });
        guideObserver.observe(valueSection);
        [creamButtons[0]?.querySelector('img'), vessel.querySelector('img')].forEach(image => {
          image?.addEventListener('load', scheduleGuide, { once: true });
        });
      }
    }

    const form = root.querySelector('.vc-form');
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('.vc-status');
    const total = form.querySelector('[data-total]');
    const success = root.querySelector('.vc-success');
    const radios = Array.from(form.querySelectorAll('input[name="programme"]'));
    let sending = false;
    let completed = false;
    let uncertain = false;
    const syncOffer = () => {
      if (sending || completed || uncertain) return;
      const selected = radios.find(radio => radio.checked);
      total.textContent = selected ? selected.dataset.price + ' ' + form.dataset.currency : form.dataset.emptyTotal;
      button.textContent = form.dataset.submitLabel + (selected ? ' · ' + selected.dataset.price + ' ' + form.dataset.currency : '') + ' ←';
      status.textContent = '';
    };
    radios.forEach(radio => radio.addEventListener('change', syncOffer));
    window.addEventListener('pageshow', syncOffer);
    syncOffer();
    const videos = root.querySelectorAll('video[data-vc-poster]');
    const loadPoster = video => {
      video.poster = video.dataset.vcPoster;
      delete video.dataset.vcPoster;
    };
    if ('IntersectionObserver' in window) {
      const posterObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          loadPoster(entry.target);
          posterObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' });
      videos.forEach(video => posterObserver.observe(video));
    } else videos.forEach(loadPoster);
    const phone = form.elements.phone;
    phone.addEventListener('input', () => phone.setCustomValidity(''));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (sending || completed || uncertain) return;
      const normalizedPhone = normalize(phone.value);
      phone.setCustomValidity(/^0[67]\d{8}$/.test(normalizedPhone) ? '' : form.dataset.invalidPhone);
      if (!form.reportValidity()) return;
      const selected = radios.find(radio => radio.checked);
      // The confirmation team collects customer identity and delivery city by phone.
      // Explicit placeholders satisfy the existing COD app's legacy order schema.
      const name = 'Client Vivalle - a confirmer';
      const city = 'A confirmer';
      if (!selected) { status.textContent = form.dataset.incomplete; return; }
      sending = true;
      button.disabled = true;
      const originalLabel = button.textContent;
      button.textContent = form.dataset.sending;
      status.textContent = '';
      const isShopifyOrder = form.dataset.endpoint.startsWith('/apps/vivalle-order');
      let eventId = 'purchase_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
      let submissionKey = '';
      if (isShopifyOrder) {
        const bytes = new TextEncoder().encode(JSON.stringify([name, normalizedPhone, city, selected.dataset.count]));
        const hash = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)), x => x.toString(16).padStart(2, '0')).join('');
        submissionKey = 'vivalle_order_' + hash;
        try {
          const previous = JSON.parse(sessionStorage.getItem(submissionKey) || 'null');
          if (previous && Date.now() - previous.created < 86400000) eventId = previous.id;
          else sessionStorage.setItem(submissionKey, JSON.stringify({ id: eventId, created: Date.now() }));
        } catch { /* Server also protects against duplicate submissions. */ }
      }
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST', credentials: isShopifyOrder ? 'same-origin' : 'omit', signal: controller.signal,
          body: new URLSearchParams({ ...trafficContext, name, phone: normalizedPhone, city, programme: selected.value, offer: selected.dataset.count, website: form.elements.website?.value || '', fbp: cookie('_fbp'), fbc: cookie('_fbc'), user_agent: navigator.userAgent, page_url: location.href, lead_event_id: eventId })
        });
        const result = (await response.text()).trim();
        if (isShopifyOrder) {
          let data;
          try { data = JSON.parse(result); } catch { throw new Error('Unconfirmed order'); }
          if (!response.ok || data.ok !== true || !data.orderName) {
            if ([400, 403, 413, 422, 429, 503].includes(response.status)) {
              status.textContent = response.status === 429 ? 'المرجو الانتظار قليلاً قبل المحاولة من جديد.' : 'تعذر إرسال الطلب الآن. المرجو المحاولة من جديد.';
              button.disabled = false;
              button.textContent = originalLabel;
              return;
            }
            throw new Error('Unconfirmed order');
          }
        } else if (!response.ok || !/^(OK|SUCCESS)$/i.test(result)) throw new Error('Unconfirmed order');
        completed = true;
        success.querySelector('[data-success-offer]').textContent = selected.closest('.vc-offer').querySelector('.vc-offer-card>b').textContent + ' · ' + selected.dataset.price + ' ' + form.dataset.currency;
        form.hidden = true;
        success.hidden = false;
        success.focus();
        const payload = { value: Number(selected.dataset.price), currency: 'MAD', content_name: 'Vivalle x' + selected.dataset.count, content_type: 'product', content_id: selected.dataset.sku, quantity: 1, price: Number(selected.dataset.price) };
        // Forward confirmed orders to Shopify's consent-managed custom pixels.
        try {
          const analytics = window.Shopify?.analytics;
          if (typeof analytics?.publish === 'function') {
            Promise.resolve(analytics.publish('vivalle:order_confirmed', { ...payload, event_id: eventId })).catch(() => {});
          }
        } catch { /* Pixel failures must not interrupt order confirmation. */ }
        document.dispatchEvent(new CustomEvent('vivalle:order-confirmed', { detail: { ...payload, event_id: eventId } }));
      } catch {
        uncertain = true;
        status.textContent = isShopifyOrder ? 'كنتحققو من تسجيل الطلب. المرجو ما تعاودش ترسلو دابا لتفادي التكرار. يمكنك تحديث الصفحة للتحقق بنفس رقم الطلب.' : form.dataset.error;
        button.textContent = originalLabel;
      } finally { clearTimeout(timeout); sending = false; }
    });
    const track = root.querySelector('.vc-results');
    const cases = Array.from(track.querySelectorAll('.vc-result'));
    const previous = root.querySelector('[data-result-prev]');
    const next = root.querySelector('[data-result-next]');
    const count = root.querySelector('[data-result-count]');
    const dots = root.querySelector('[data-result-dots]');
    const indicators = cases.map((_, index) => {
      const dot = document.createElement('span');
      dot.className = 'vc-result-dot';
      dot.setAttribute('aria-hidden', 'true');
      dots.appendChild(dot);
      return dot;
    });
    let caseIndex = 0;
    let scheduled = false;
    const lastStart = () => Math.max(0, cases.length - (window.innerWidth > 650 ? 2 : 1));
    const updateCases = () => {
      const bounds = track.getBoundingClientRect();
      caseIndex = Math.min(lastStart(), cases.reduce((best, item, index) => {
        const distance = Math.abs(bounds.right - item.getBoundingClientRect().right);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index);
      count.textContent = (caseIndex + 1) + ' / ' + cases.length;
      indicators.forEach((dot, index) => dot.classList.toggle('is-active', index === caseIndex));
      previous.disabled = caseIndex === 0;
      next.disabled = caseIndex >= lastStart();
      scheduled = false;
    };
    track.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateCases); } }, { passive: true });
    const move = direction => {
      const targetIndex = Math.max(0, Math.min(lastStart(), caseIndex + direction));
      const distance = cases[targetIndex].getBoundingClientRect().right - track.getBoundingClientRect().right;
      track.scrollBy({ left: distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      caseIndex = targetIndex;
      count.textContent = (caseIndex + 1) + ' / ' + cases.length;
      indicators.forEach((dot, index) => dot.classList.toggle('is-active', index === caseIndex));
      previous.disabled = caseIndex === 0;
      next.disabled = caseIndex >= lastStart();
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? 1 : -1);
      }
    });
    window.addEventListener('resize', updateCases, { passive: true });
    updateCases();
    const audioPlayers = Array.from(root.querySelectorAll('audio'));
    audioPlayers.forEach(player => player.addEventListener('play', () => audioPlayers.forEach(other => { if (other !== player) other.pause(); })));
    const voiceSection = root.querySelector('.vv-voice-section');
    if (voiceSection && 'IntersectionObserver' in window) {
      const voiceObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        voiceObserver.disconnect();
        initializeVoiceNotes(root);
      }, { rootMargin: '500px 0px' });
      voiceObserver.observe(voiceSection);
    } else initializeVoiceNotes(root);
    const sticky = root.querySelector('.vc-sticky');
    const heroAction = root.querySelector('.vc-hero-action');
    const orderPanel = root.querySelector('.vc-order-panel');
    let orderVisible = false;
    // Place this fixed CTA directly under body: the landing-page wrapper
    // uses overflow:hidden, which can clip a moved CTA in iOS Safari/Chrome.
    sticky.classList.add('vc-sticky-portal');
    sticky.style.transform = '';
    document.body.appendChild(sticky);
    let stickyViewportFrame = 0;
    const alignStickyViewport = () => {
      stickyViewportFrame = 0;
      if (sticky.hidden || window.innerWidth >= 768) return;
      // Derive a fresh offset from viewport geometry; never accumulate shifts.
      const viewport = window.visualViewport;
      const shift = viewport ? viewport.offsetTop + viewport.height - window.innerHeight : 0;
      sticky.style.setProperty('--vv-viewport-shift', Math.round(shift) + 'px');
    };
    const queueStickyViewportAlign = () => {
      if (!stickyViewportFrame) stickyViewportFrame = requestAnimationFrame(alignStickyViewport);
    };
    const updateSticky = () => {
      const editing = root.contains(document.activeElement) && document.activeElement.matches('input, textarea, select, [contenteditable="true"]');
      const keyboardOpen = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
      sticky.hidden = heroAction.getBoundingClientRect().bottom > 0 || orderVisible || editing || keyboardOpen || completed;
      queueStickyViewportAlign();
    };
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === orderPanel) orderVisible = entry.isIntersecting;
      });
      updateSticky();
    }, { threshold: 0 });
    visibility.observe(heroAction);
    visibility.observe(orderPanel);
    document.addEventListener('focusin', updateSticky);
    document.addEventListener('focusout', () => requestAnimationFrame(updateSticky));
    window.addEventListener('resize', updateSticky, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', updateSticky, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('scroll', queueStickyViewportAlign, { passive: true });
    window.addEventListener('scroll', queueStickyViewportAlign, { passive: true });
    window.addEventListener('orientationchange', queueStickyViewportAlign, { passive: true });
    document.addEventListener('vivalle:order-confirmed', updateSticky);
  };
  const start = scope => scope.querySelectorAll('.vc').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();








